<div class="facility-users">
  <div class="facility-users__header">
    <div class="facility-users__title">Facility users</div>
    <div *ngIf="facilityName" class="facility-users__subtitle">
      {{ facilityName }}
    </div>
  </div>

  <mat-form-field appearance="outline" class="facility-users__search">
    <mat-label>Search users</mat-label>
    <input
      matInput
      type="text"
      [(ngModel)]="searchQuery"
      (ngModelChange)="onSearchChange()" />
    <mat-hint>Search by name, email, or role</mat-hint>
    <mat-icon matPrefix>search</mat-icon>
  </mat-form-field>

  <div *ngIf="isLoading" class="facility-users__loading">
    <mat-progress-spinner diameter="28"></mat-progress-spinner>
    <span>Loading users...</span>
  </div>

  <div *ngIf="loadError" class="facility-users__error">
    {{ loadError }}
  </div>

  <div *ngIf="!isLoading && !loadError && filteredUsers.length === 0" class="facility-users__empty">
    No facility users found.
  </div>

  <div *ngIf="!isLoading && !loadError && filteredUsers.length > 0" class="facility-users__list">
    <button
      *ngFor="let user of filteredUsers; trackBy: trackByUserId"
      type="button"
      class="facility-users__item"
      [class.selected]="isUserSelected(user)"
      (click)="toggleUser(user)">
      <mat-checkbox [checked]="isUserSelected(user)"></mat-checkbox>
      <div class="facility-users__item-info">
        <div class="facility-users__item-name">{{ user.name || user.email || 'User' }}</div>
        <div class="facility-users__item-meta">
          <span *ngIf="user.email">{{ user.email }}</span>
          <span *ngIf="user.role" class="facility-users__role">{{ getRoleLabel(user.role) }}</span>
        </div>
      </div>
    </button>
  </div>
</div>
